import groq from "groq"

export const noteProjection = () => groq`
  "id": _id,
  "rev": _rev,
  customerNumber,
  noteNumber,
  lineNumber,
  text,
  displayDuringReceiptCreation,
  modifiedAt
`
